import { render, staticRenderFns } from "./CommercialFreestandingMedicalProperty.vue?vue&type=template&id=31111ae4&scoped=true&"
import script from "./CommercialFreestandingMedicalProperty.vue?vue&type=script&lang=ts&"
export * from "./CommercialFreestandingMedicalProperty.vue?vue&type=script&lang=ts&"
import style0 from "./CommercialFreestandingMedicalProperty.vue?vue&type=style&index=0&id=31111ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31111ae4",
  null
  
)

export default component.exports